module.exports = __webpack_public_path__ + "static/media/shaff1118.b2f9e30b.jpg";